module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.casesReady) ? _c('div', {
    staticClass: "our-work"
  }, [_c('div', {
    staticClass: "our-work--title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "our-work-swiper-container swiper-container wide-slider"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.cases), function(caseitem, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('router-link', {
      staticClass: "box",
      attrs: {
        "tag": "div",
        "to": '/' + _vm.slug + '/' + caseitem.slug
      }
    }, [_c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + (caseitem && caseitem.better_featured_image && caseitem.better_featured_image.source_url) + ' )'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(caseitem && caseitem.title && caseitem.title.rendered)
      }
    })])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "our-work-swiper-prev our-work-wide-slider-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "our-work-swiper-next our-work-wide-slider-next"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52135828","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurWorkSlider.vue
// module id = 340
// module chunks = 0